import * as yup from 'yup'
import {
  validateRequiredDate,
  validateStartBeforeEndDate
} from '../../../../utils'
import {
  MutationSavePaymentExemptionArgs,
  PaymentExemptionInput
} from '../../../../utils/classes/graphql'

const validationSchema = yup.object().shape({
  alkupvm: validateRequiredDate(
    'pages.paymentExemptionsPage.startDate.error.required'
  ),
  loppupvm: validateStartBeforeEndDate<PaymentExemptionInput>(
    'alkupvm',
    'pages.paymentExemptionsPage.endDate.error.endBeforeStart',
    'pages.paymentExemptionsPage.endDate.error.required'
  ),
  syykoodi: yup
    .string()
    .nullable()
    .required('pages.paymentExemptionsPage.reason.error.required')
})

const createVariables = (
  values: PaymentExemptionInput
): MutationSavePaymentExemptionArgs => ({
  paymentExemption: {
    ...values
  }
})

const initialValues: PaymentExemptionInput = {
  alkupvm: null,
  loppupvm: null,
  syykoodi: null
}

export const usePaymentExemptionFormData = () => {
  return { createVariables, initialValues, validationSchema }
}
